import { CopyOutlined } from '@ant-design/icons';
import { App } from 'antd';
import { memo, useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

interface WebhookSecretProps {
  id: string;
}

export const ApplicationId = memo(({ id }: WebhookSecretProps) => {
  const [isSuccess, setSuccess] = useState(false);
  const { message } = App.useApp();

  useEffect(
    () =>
      void (isSuccess && message.success('Application ID was successfully copied', () => setSuccess(false)),
      [isSuccess]),
  );

  return (
    <CopyToClipboard text={id} onCopy={() => setSuccess(true)}>
      <span style={{ cursor: 'pointer' }}>
        {id} <CopyOutlined />
      </span>
    </CopyToClipboard>
  );
});
